import { pipe } from 'fp-ts/function';
import { array, boolean, intersect, nullable, partial, refine, struct } from 'io-ts/Decoder';

import { Id as TopicId } from '../../../../email/subscription/topic/Id';
import { Id as OrganizationId } from '../../../../organization/Id';

/** More than anyone could change by hand in one go; keeps one request to a bounded write. */
const MAX_CHANGES = 500;

const Change = pipe(
	struct({
		topic: TopicId,
		/** null clears the choice, so the topic falls back to the layer above. */
		enabled: nullable(boolean),
	}),
	intersect(
		partial({
			/** Omitted for the all-organisations layer. */
			organizationId: OrganizationId,
		})
	)
);

export const Request = struct({
	changes: pipe(
		array(Change),
		refine(
			(changes): changes is typeof changes => changes.length <= MAX_CHANGES,
			`at most ${MAX_CHANGES} changes`
		)
	),
});
